module.exports = "<router-outlet>\n    <app-spinner></app-spinner>\n</router-outlet>\n<app-loading></app-loading>\n"